import { FC } from 'react';

import { Badge, Button } from '@mui/material';
import { GridRowSelectionModel } from '@mui/x-data-grid-pro';

type ShowSelectedRowsButtonProps = {
  selectionModel: GridRowSelectionModel;
  showSelectedRows: boolean;
  setShowSelectedRows: (value: boolean) => void;
};

const ShowSelectedRowsButton: FC<ShowSelectedRowsButtonProps> = ({
  selectionModel,
  showSelectedRows,
  setShowSelectedRows,
}) => {
  return (
    <Badge badgeContent={selectionModel.length} color='primary'>
      <Button
        onClick={() => {
          if (selectionModel.length > 0) {
            setShowSelectedRows(!showSelectedRows);
          }
        }}
        variant='contained'
        color='inherit'
        size='large'
        sx={{
          bgcolor: 'grey.100',
          color: 'text.secondary',
          boxShadow: 'none',
          textTransform: 'none',
        }}
      >
        {showSelectedRows && selectionModel.length > 0
          ? 'Show All'
          : 'Show Selected'}
      </Button>
    </Badge>
  );
};

export default ShowSelectedRowsButton;
